
import {Vue, Component} from 'vue-property-decorator';
import {Decimal} from "decimal.js";
import {Message} from "element-ui";
import {ElForm} from "element-ui/types/form";

@Component({})
export default class EditInvoice extends Vue {

  private showDialog = false;

  public openDialog() {
    this.showDialog = true;
  }

  public closeDialog(clear:boolean) {
    this.showDialog = false;
    if (clear) {
      this.clearVariable();
    }
  }

  /**
   * 上传成功时/取消时清空所有变量内容
   */
  public clearVariable() {
    this.clearTotalAmount();
    this.clearItems()
    this.resetForm();
  }
// 表格的内容
  // 表单项的名称对齐方式
  private labelPosition = "left";
  private req = new CreateInvoiceReq();
  private submitForm(refName:string) {
    (this.$refs[refName] as ElForm).validate(valid => {
      if (!valid) {
        return false;
      } else {
        if (this.req.invoiceItemReqs  && this.req.invoiceItemReqs.length ===0) {
          this.errorMessage('请增加发票明细')
          return false;
        }
        this.closeDialog(false);
        this.$emit('editInvoiceSuccess', this.req);
        return true;
      }
    })
  }
  private resetForm() {
    let $ref = this.$refs['formRef'] as ElForm;
    if ($ref) {
      $ref.resetFields();
    }
  }
  private updatePurchaserUsci(optionVal: string) {

    if (optionVal === '温州嘉锐实业有限公司') {
      this.req.purchaserUsci = '91330302MA285RGA2B';
    }
    if (optionVal === '温州华强汽配有限公司') {
      this.req.purchaserUsci = '91330302777238819A';
    }
  }
  private replaceBlank(prop: string) {
    this.req[prop] = this.req[prop].replace(/\s+/g, '');
  }

  private rules = {
    completeInvoice: [
      {required: true, message: '请填写完整发票号码', trigger: 'blur'},
      {pattern: /^\d{20}$/, message: '发票号码应为长度为20位的纯数字', trigger: 'blur'}
    ],
    invoiceDate: [
      {required: true, message: '请填写开票日期', trigger: 'blur'},
      {pattern: /^\d{4}年(0[1-9]|1[0-2])月(0[1-9]|[12][0-9]|3[01])日$/, message: '开票日期应为xxxx年xx月xx日格式', trigger: 'blur'}
    ],
    purchaser: [
      {required: true, message: '请选择购买方名称', trigger: 'blur'},
    ],
    purchaserUsci: [
      {required: true, message: '请选择购买方税号', trigger: 'blur'}
    ],
    seller: [
      {required: true, message: '请填写销售方名称', trigger: 'blur'}
    ],
    sellerUsci: [
      {required: true, message: '请填写销售方税号', trigger: 'blur'},
      {pattern: /^[0-9A-Z]{18}$/, message: '税号应为长度为18位的数字+大写英文字母', trigger: 'blur'}
    ]
  }
  /**
   * 切换采购方
   * @param optionVal 采购方的选项名称
   * @private
   */
// table 内容
  private clearItems() {
    this.req.invoiceItemReqs = [];
  }
  /**
   * 移除某行内容
   * @param index
   * @param rows
   */
  public deleteRow(index: number, rows: InvoiceItemReq[]) {
    let row: InvoiceItemReq = rows[index];
    this.totalAmount = new Decimal(this.totalAmount)
        .sub(new Decimal(row.amount))
        .sub(new Decimal(row.rateAmount));
    rows.splice(index, 1);
  }

  /**
   * 合计行
   * @param param
   * @private
   */
  private getSummaries(param) {
    const { columns, data } = param;
    const sums = [];
    columns.forEach((column, index) => {
      if (index === 0) {
        sums[index] = '合计';
        return;
      }
      const values = data.filter(()=> {
        let qtyCol = column.property === 'qty';
        let amountCol = column.property === 'amount';
        let rateAmountCol = column.property === 'rateAmount';
        if (qtyCol || amountCol || rateAmountCol) {
          return qtyCol || amountCol || rateAmountCol;
        }
      }).map(item => Number(item[column.property]));
      if (!values.every(value => isNaN(value))) {
        let calResult = values.reduce((prev, curr) => {
          const value = Number(curr);
          if (!isNaN(value)) {
            return  prev + curr;
          } else {
            return  prev;
          }
        }, 0);
        sums[index] =  '¥' +  calResult;
      } else {
        sums[index] = '';
      }
    });
    return sums;
  }
  // 价税合计金额
  private totalAmount = new Decimal(0);
  private clearTotalAmount() {
    this.totalAmount = new Decimal(0);
  }
// popover 内容
  private showPopoverVisible = false;
  // 嵌套form的内容
  private invoiceItem = new InvoiceItemReq();
  private initItemForm() {
    this.showPopoverVisible = true;
    this.invoiceItem = new InvoiceItemReq();
  }

  private replaceItemNameBlank() {
    this.invoiceItem.name = this.invoiceItem.name.replace(/\s+/g, '');
  }
  /**
   * 重置Form
   * @param refName
   * @private
   */
  private resetItemForm(refName) {
    (this.$refs[refName] as ElForm).resetFields()
  }

  /**
   * 提交Form
   * @param refName
   * @private
   */
  private submitItemForm(refName) {
    (this.$refs[refName] as ElForm).validate(valid => {
      if (!valid) {
        return false;
      } else {
       if (this.validateAmount()) {
         updateReqItems.call(this);
         this.showPopoverVisible = false;
         return true;
       }
       return false;
      }
    });

    function updateReqItems() {
      this.invoiceItem = {
        ...this.invoiceItem,
        name: this.invoiceItem.name.replace(/\s+/g, '')
      }
      this.req.invoiceItemReqs.push(this.invoiceItem);
      this.totalAmount = this.req.invoiceItemReqs.reduce((acc, cur) => {
        return new Decimal(acc).add(new Decimal(cur.rateAmount).add(new Decimal(cur.amount)));
      }, 0);
    }
  }

  /**
   * 校验税额
   * @private
   */
  private validateAmount() {
    let item: InvoiceItemReq = this.invoiceItem;
    let convertRate = this.convertRate(item);
    let calRateAmount = new Decimal(item.amount).mul(convertRate).toFixed(2);
    let rateAmountEq = new Decimal(calRateAmount)
        .comparedTo(new Decimal(item.rateAmount)) === 0;
    if (!rateAmountEq) {
      this.errorMessage('金额（'+ item.amount +'）和税率（'+item.rate+'）计算出的【税额（' + calRateAmount + '）】和【填写税额（' + item.rateAmount + '）】不相等');
      return false;
    }
    return true;
  }

  /**
   * 计算单价。 (金额+税额) / (1+税率) / 数量
   * @private
   */
  private calPrice() {
    let item: InvoiceItemReq = this.invoiceItem;
    if (item.amount !== null && item.qty !== null && item.rate !=='' && item.rateAmount !== null) {
      let rate = this.convertRate(item);
      let price = new Decimal(item.amount).add(item.rateAmount)
          .div(new Decimal(1).add(new Decimal(rate)))
          .div(item.qty).toFixed(13);
      this.$set(this.invoiceItem, 'price', Number(price))
    }
  }

  /**
   * 转化税率，将其转化为可计算的
   * @param item
   * @private
   */
  private convertRate(item: InvoiceItemReq): Decimal {
    let rate = item.rate;
    if (item.rate.indexOf('%')) {
      rate = item.rate.replace('%', '');
    }
    return new Decimal(rate).div(100);
  }

  private itemRules = {
    name: [
      {required: true, message: '请填写完整的项目名称', trigger: 'blur'},
      {pattern: /^\*.+\*.+$/, message: '请复制发票内的项目名称', trigger: 'blur'}
    ],
    unit: [
      {required: true, message: '请填写单位', trigger: 'blur'},
    ],
    qty: [
      {required: true, message: '数量不能为空', trigger: 'blur'},
      {type: 'number', message: '数量必须为整数值', trigger: 'blur'},
      {validator: (rule, value, callback) => {
          if (value <= 0) {
            callback(new Error('数量需要大于0'));
          } else {
            callback();
          }
        }, trigger: 'blur'}
    ],
    price: [
      {required: true, message: '单价不能为空', trigger: 'blur'},
      {pattern: /^\d+(\.\d+)?$/, message: '单价需要大于0的数字', trigger: 'blur'}
    ],
    amount: [
      {required: true, message: '金额不能为空', trigger: 'blur'},
      {pattern: /^\d+(\.\d+)?$/, message: '金额需要大于0的数字', trigger: 'blur'}
    ],
    rate: [
      {required: true, message: '税率不能为空', trigger: 'blur'},
      {pattern: /^[1-9]\d*(%?)$/, message: '税率是纯数字/百分比', trigger: 'blur'}
    ],
    rateAmount: [
      {required: true, message: '税额不能为空', trigger: 'blur'},
      {pattern: /^\d+(\.\d+)?$/, message: '税额需要大于0的数字', trigger: 'blur'}
    ],
  }

  private errorMessage(message: string) {
    Message.error({
      message: message,
      duration: 2000
    })
  }
}

export class CreateInvoiceReq {
  completeInvoice: string;
  purchaser: string;
  purchaserUsci: string;
  invoiceDate: string;
  seller: string;
  sellerUsci: string;
  invoiceItemReqs: InvoiceItemReq[];

  constructor() {
    this.completeInvoice = '';
    this.purchaser = '温州华强汽配有限公司';
    this.purchaserUsci = '91330302777238819A';
    this.seller = '';
    this.sellerUsci = '';
    this.invoiceDate = '';
    this.invoiceItemReqs = [];
  }
}

class InvoiceItemReq {
  name: string;
  unit: string;
  qty: number;
  price: number;
  amount: number;
  rate: string;
  rateAmount: number;

  constructor() {
    this.name = '';
    this.unit = '';
    this.qty = null;
    this.price = null;
    this.amount = null;
    this.rate = '13%';
    this.rateAmount = null;
  }
}
